export const netherWorld = [
  {
    key: "hav2Dl6jsIybijgBGHzNF",
    pos: [-2, 0, -5],
    texture: "obsidian",
  },
  {
    key: "kN8-zvNA3PRzy6NIH64Me",
    pos: [-1, 0, -5],
    texture: "obsidian",
  },
  {
    key: "_6r_lroOW9IahfnlHsQb4",
    pos: [0, 0, -5],
    texture: "obsidian",
  },
  {
    key: "diFcTYcoM0h0cRE2Bmfki",
    pos: [1, 0, -5],
    texture: "obsidian",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "DiBuvrEsxUqyaetvMvbep",
    pos: [1, 1, -5],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "2uHQILLVMcxzxhUMLWrzp",
    pos: [1, 2, -5],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "zcmyddKV4PbPpbZnPEBek",
    pos: [1, 3, -5],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "xEvkLKb-zC3izjshTeWAJ",
    pos: [1, 4, -5],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "2LiTL4CXffwIDladS7Wz-",
    pos: [0, 4, -5],
    texture: "obsidian",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "rWgInGOL1SwmbJKKylNMP",
    pos: [-1, 4, -5],
    texture: "obsidian",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "QTn2NY4NbFCviNNbCNCCW",
    pos: [-2, 4, -5],
    texture: "obsidian",
    rotation: [0, 0, 1.5707963267948966],
  },
  {
    key: "UhEhxw2Ax-lGdBeVJqRVW",
    pos: [-2, 3, -5],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "LG_-dA0z925raf6wyupTA",
    pos: [-2, 2, -5],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "c4UtRWc-shZ37gfxi6R4K",
    pos: [-2, 1, -5],
    texture: "obsidian",
    rotation: [0, 0, 0],
  },
  {
    key: "lTyAErBfFxImfsamAyeTL",
    pos: [4, 0, -13],
    texture: "react",
  },
  {
    key: "fhLdXui95raEbl2FYJtZ-",
    pos: [5, 0, -13],
    texture: "react",
  },
  {
    key: "MGUuYcL5GLkFONji3cCLm",
    pos: [5, 1, -13],
    texture: "react",
    rotation: [0, 0, 0],
  },
  {
    key: "7eephvxO9oHuEKJARLjuk",
    pos: [4, 1, -13],
    texture: "react",
    rotation: [0, 0, 0],
  },
  {
    key: "KrApvwpCIvJfiuk49rjIp",
    pos: [7, 0, -13],
    texture: "next_js",
  },
  {
    key: "Ff22p5jjYAa5MKi-FK1VB",
    pos: [8, 0, -13],
    texture: "next_js",
  },
  {
    key: "n72mOqjvEDJwXcezL9AFb",
    pos: [7, 1, -13],
    texture: "next_js",
    rotation: [0, 0, 0],
  },
  {
    key: "8mkGufYylzrkR-8apZSOu",
    pos: [8, 1, -13],
    texture: "next_js",
    rotation: [0, 0, 0],
  },
  {
    key: "Mimx4BuxUUKDCKSsJvKHa",
    pos: [10, 0, -13],
    texture: "mongo_db",
  },
  {
    key: "0qcMGwtOW3iz04YMXh93A",
    pos: [11, 0, -13],
    texture: "mongo_db",
  },
  {
    key: "IcKN1dEXT3sOzrmBPWywK",
    pos: [10, 1, -13],
    texture: "mongo_db",
    rotation: [0, 0, 0],
  },
  {
    key: "l9hmk6Vm9loZtSNaAcSTG",
    pos: [11, 1, -13],
    texture: "mongo_db",
    rotation: [0, 0, 0],
  },
  {
    key: "Ksn4djz9NOUwoowf4mALQ",
    pos: [13, 0, -13],
    texture: "express",
  },
  {
    key: "wE9Al9r4WlC1XTT5Fw8zV",
    pos: [14, 0, -13],
    texture: "express",
  },
  {
    key: "0LuZsroeZWBo4eV6wtegi",
    pos: [13, 1, -13],
    texture: "express",
    rotation: [0, 0, 0],
  },
  {
    key: "OhEC--EIru2c9olVHPkNM",
    pos: [14, 1, -13],
    texture: "express",
    rotation: [0, 0, 0],
  },
  {
    key: "MkcuZ5SsIYNycCSJ94m3B",
    pos: [16, 0, -13],
    texture: "node_js",
  },
  {
    key: "hxtLo0K53io0Og5x94kWN",
    pos: [17, 0, -13],
    texture: "node_js",
  },
  {
    key: "Gkqoyo6l6kWLvyZLuG_dz",
    pos: [16, 1, -13],
    texture: "node_js",
    rotation: [0, 0, 0],
  },
  {
    key: "403eFNlANJkrk9k7_IgJz",
    pos: [17, 1, -13],
    texture: "node_js",
    rotation: [0, 0, 0],
  },
  {
    key: "__CdJJeClSSdNwwJowQQ3",
    pos: [19, 0, -13],
    texture: "bootstrap",
  },
  {
    key: "dm5QyY2niKWSrQgBAJzmn",
    pos: [20, 0, -13],
    texture: "bootstrap",
  },
  {
    key: "pUe4ClIt4gkhBvYd0rEG4",
    pos: [19, 1, -13],
    texture: "bootstrap",
    rotation: [0, 0, 0],
  },
  {
    key: "Qaj3t_Ht0mFI3O_YZOz8J",
    pos: [20, 1, -13],
    texture: "bootstrap",
    rotation: [0, 0, 0],
  },
  {
    key: "858WV1VLMzQ6ztjnJbHNu",
    pos: [22, 0, -13],
    texture: "tailwind",
  },
  {
    key: "gLoEbMAiFW4fqfFcH3xKH",
    pos: [23, 0, -13],
    texture: "tailwind",
  },
  {
    key: "4qQglwgykGf0sVsuQY3pe",
    pos: [22, 1, -13],
    texture: "tailwind",
    rotation: [0, 0, 0],
  },
  {
    key: "e9INGcy4Zcxq0RHbREn3p",
    pos: [23, 1, -13],
    texture: "tailwind",
    rotation: [0, 0, 0],
  },
  {
    key: "_JDczM4enzTyccKHyL-HR",
    pos: [25, 0, -13],
    texture: "git",
  },
  {
    key: "dQkQ7_GU6xZyshxby7nsL",
    pos: [26, 0, -13],
    texture: "git",
  },
  {
    key: "TcotyNxvZz7Op9fngCfvT",
    pos: [25, 1, -13],
    texture: "git",
    rotation: [0, 0, 0],
  },
  {
    key: "V4qn5lcGAvItxQ2u6JN7Z",
    pos: [26, 1, -13],
    texture: "git",
    rotation: [0, 0, 0],
  },
  {
    key: "09f8Jaz_DCD4iUqkUgcyq",
    pos: [28, 0, -13],
    texture: "flask",
  },
  {
    key: "XQzS4CIfVZjpqDOBW5gNg",
    pos: [29, 0, -13],
    texture: "flask",
  },
  {
    key: "lN9lWBNtYxGR-25ayBH2z",
    pos: [28, 1, -13],
    texture: "flask",
    rotation: [0, 0, 0],
  },
  {
    key: "RZjBM3lNg5Q_jbNky6qvW",
    pos: [29, 1, -13],
    texture: "flask",
    rotation: [0, 0, 0],
  },
  {
    key: "z9NjEIHNcKBCKDRkw3PX0",
    pos: [-5, 0, -13],
    texture: "python",
  },
  {
    key: "bvB0XlEjiHvmLNZenS6Wv",
    pos: [-6, 0, -13],
    texture: "python",
  },
  {
    key: "rg_dWfIxJSbqcMYqJ-zjI",
    pos: [-5, 1, -13],
    texture: "python",
    rotation: [0, 0, 0],
  },
  {
    key: "H6yj644_m3ySoPeV0OVFT",
    pos: [-6, 1, -13],
    texture: "python",
    rotation: [0, 0, 0],
  },
  {
    key: "H8AYjspepp7qFrvLR7Q68",
    pos: [-8, 0, -13],
    texture: "java",
  },
  {
    key: "s44bvx1Es2_TaHdQoEBiq",
    pos: [-9, 0, -13],
    texture: "java",
  },
  {
    key: "QBIQKwzRonVHCs2jH0vVz",
    pos: [-8, 1, -13],
    texture: "java",
    rotation: [0, 0, 0],
  },
  {
    key: "gUaXWStwHu6I4cFnVTB_i",
    pos: [-9, 1, -13],
    texture: "java",
    rotation: [0, 0, 0],
  },
  {
    key: "2oVli5JLOjL-Fdp0Epi1m",
    pos: [-11, 0, -13],
    texture: "github",
  },
  {
    key: "aKzzn_eXwCmlHv-eHuwgb",
    pos: [-12, 0, -13],
    texture: "github",
  },
  {
    key: "onqV3kRJFGDyZVVPDoXgw",
    pos: [-11, 1, -13],
    texture: "github",
    rotation: [0, 0, 0],
  },
  {
    key: "X2RUstTGSbOi1Jy34_RE6",
    pos: [-12, 1, -13],
    texture: "github",
    rotation: [0, 0, 0],
  },
  {
    key: "ZZUSDd9RZJ-qCPkQSkmnF",
    pos: [-14, 0, -13],
    texture: "docker",
  },
  {
    key: "5CiWV20Rgn8stW3FawD9m",
    pos: [-15, 0, -13],
    texture: "docker",
  },
  {
    key: "-B3_HI5MsxhJeRktywPZz",
    pos: [-14, 1, -13],
    texture: "docker",
    rotation: [0, 0, 0],
  },
  {
    key: "0A7AK4S5C3U3Y4-xzXhNQ",
    pos: [-15, 1, -13],
    texture: "docker",
    rotation: [0, 0, 0],
  },
  {
    key: "klBMLslpDVN3pNK0p0XFe",
    pos: [-17, 0, -13],
    texture: "sql",
  },
  {
    key: "CxQKEepZpb-wt_xCyFa52",
    pos: [-18, 0, -13],
    texture: "sql",
  },
  {
    key: "9I1doBzaCIECMw3mAN9fn",
    pos: [-17, 1, -13],
    texture: "sql",
    rotation: [0, 0, 0],
  },
  {
    key: "1gdajvzNq5tJbRbKiCJ6l",
    pos: [-18, 1, -13],
    texture: "sql",
    rotation: [0, 0, 0],
  },
  {
    key: "DBJT4QG85jtzOrRCqRUdf",
    pos: [-20, 0, -13],
    texture: "html",
  },
  {
    key: "iV_kcwJoEJ6yjL864zaw8",
    pos: [-21, 0, -13],
    texture: "html",
  },
  {
    key: "7DX-COtnPkDEy-r-HPmVw",
    pos: [-20, 1, -13],
    texture: "html",
    rotation: [0, 0, 0],
  },
  {
    key: "smza6uk_sr6gXSIsTYv86",
    pos: [-21, 1, -13],
    texture: "html",
    rotation: [0, 0, 0],
  },
  {
    key: "WoleYNPEci4yX7kbXeuZl",
    pos: [-23, 0, -13],
    texture: "css",
  },
  {
    key: "0q27q_pHdD5SJFQGO_GzE",
    pos: [-24, 0, -13],
    texture: "css",
  },
  {
    key: "yl8SvlMzze93ufN64xaot",
    pos: [-23, 1, -13],
    texture: "css",
    rotation: [0, 0, 0],
  },
  {
    key: "m17Rk5sAYs1s3-bV6kAar",
    pos: [-24, 1, -13],
    texture: "css",
    rotation: [0, 0, 0],
  },
  {
    key: "y-t-9MxDY2SZfeQqHLQWu",
    pos: [-26, 0, -13],
    texture: "javascript",
  },
  {
    key: "AjUX7szrxx5JOcvDehjRC",
    pos: [-27, 0, -13],
    texture: "javascript",
  },
  {
    key: "u6yV4MMmgn2--lJGPJ5sc",
    pos: [-26, 1, -13],
    texture: "javascript",
    rotation: [0, 0, 0],
  },
  {
    key: "AGOFF5LTFpeNMutL2nTwy",
    pos: [-27, 1, -13],
    texture: "javascript",
    rotation: [0, 0, 0],
  },
  {
    key: "RMDaJwFhmKEfOWb4cKeFk",
    pos: [-29, 0, -13],
    texture: "linux",
  },
  {
    key: "_0VTb-AwMijhnuuEhnF4Q",
    pos: [-29, 1, -13],
    texture: "linux",
    rotation: [0, 0, 0],
  },
  {
    key: "OVeDiKLz0rz_y9CfumCCm",
    pos: [-30, 0, -13],
    texture: "linux",
  },
  {
    key: "BnjoDHiwZzB1i8oZ-rppq",
    pos: [-30, 1, -13],
    texture: "linux",
    rotation: [0, 0, 0],
  },
  {
    key: "astnlfRnXB8rh3xd7zGGv",
    pos: [-32, 0, -13],
    texture: "redis",
  },
  {
    key: "CU5FEB1lQVQv0lc1-adEH",
    pos: [-33, 0, -13],
    texture: "redis",
  },
  {
    key: "0tsnDdxKElmVG0nzsHkH2",
    pos: [-32, 1, -13],
    texture: "redis",
    rotation: [0, 0, 0],
  },
  {
    key: "GJvF7Lc-hrxJ167CAjSOk",
    pos: [-33, 1, -13],
    texture: "redis",
    rotation: [0, 0, 0],
  },
  {
    key: "h5MKsIpeU8jCU0x-GPFSn",
    pos: [-35, 0, -13],
    texture: "figma",
  },
  {
    key: "gYwOlLL0p0dYOiI_ECRhu",
    pos: [-36, 0, -13],
    texture: "figma",
  },
  {
    key: "9H9uoyLJlNMs8pbKyCHZj",
    pos: [-35, 1, -13],
    texture: "figma",
    rotation: [0, 0, 0],
  },
  {
    key: "zmGs4Xz-lIHtZ__LjYUku",
    pos: [-36, 1, -13],
    texture: "figma",
    rotation: [0, 0, 0],
  },
  {
    key: "xG6xDDPFxVzp-geR8S3Xx",
    pos: [31, 0, -13],
    texture: "teamcity",
  },
  {
    key: "6NEt3Pijtn0ZPVPzgGAjS",
    pos: [32, 0, -13],
    texture: "teamcity",
  },
  {
    key: "hzvbGxwWujNKwcmMCbt4o",
    pos: [31, 1, -13],
    texture: "teamcity",
    rotation: [0, 0, 0],
  },
  {
    key: "xDHDjR9nu573lrmlCdC8k",
    pos: [32, 1, -13],
    texture: "teamcity",
    rotation: [0, 0, 0],
  },
  {
    key: "3B7gxY1vBwVzJ-j6CgS5Q",
    pos: [34, 0, -13],
    texture: "selenium",
  },
  {
    key: "Dpfe-N6aTRRTYIriePjas",
    pos: [35, 0, -13],
    texture: "selenium",
  },
  {
    key: "Bfr4WFWeNvBwRdK3qVqU6",
    pos: [34, 1, -13],
    texture: "selenium",
    rotation: [0, 0, 0],
  },
  {
    key: "Hb4PzZ_1gMkERhagbU-Lt",
    pos: [35, 1, -13],
    texture: "selenium",
    rotation: [0, 0, 0],
  },
  {
    key: "JWBVmXCCZHrCcnoiK_Nrv",
    pos: [37, 0, -13],
    texture: "jira",
  },
  {
    key: "IeIhbLi2VO9CwydRJU8l-",
    pos: [38, 0, -13],
    texture: "jira",
  },
  {
    key: "gC_eb_UhhCGTd5wbKlHC8",
    pos: [37, 1, -13],
    texture: "jira",
    rotation: [0, 0, 0],
  },
  {
    key: "w43NqtFdPGAFQR9dtzERL",
    pos: [38, 1, -13],
    texture: "jira",
    rotation: [0, 0, 0],
  },
];
